import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import TablaActividades from './TablaActividades';
import TablaRefacciones from './TablaRefacciones';
//import TablaEvidencias from './TablaEvidencias'
import TablaEvidencias from './TablaEvidencia2'
import {findNumber} from "../funciones/FindNumber";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={1}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    padding:0,
    marginLeft:.6+'rem',
  },
}));

export default function SimpleTabs({orden}) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <Box  >
      <AppBar position="static" color="transparent"  >
        <Tabs 
            value={value} onChange={handleChange}
            aria-label="simple tabs example"
            indicatorColor="secondary"
            textColor="secondary"
            centered                        
        >
          <Tab label="Actividades" {...a11yProps(0)} />
          <Tab label="Refacciones" {...a11yProps(1)} />
          <Tab label="Evidencia" {...a11yProps(2)} />
        </Tabs>
      </AppBar>
      </Box>
      {findNumber('|39|') ? 
        <TabPanel value={value} index={0}>
          <TablaActividades orden={orden}/>
        </TabPanel>
      : null}
      {findNumber('|41|') ? 
        <TabPanel value={value} index={1} >
          <TablaRefacciones orden={orden}/>
        </TabPanel> 
      : null}
      {findNumber('|40|') ?   
        <TabPanel value={value} index={2} >
          <TablaEvidencias orden={orden}/>
        </TabPanel>
      : null}
    </div>
  );
}